module.exports = __webpack_public_path__ + "img/bg_day.76ba428c.svg";